"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importDefault(require("react"));
var TileDataContext_1 = require("./TileDataContext");
var FavoriteIcon_1 = __importDefault(require("../icons/FavoriteIcon"));
function FavoriteVehicle() {
    var _a = (0, TileDataContext_1.useTileDataContext)(), _b = _a.tileData, stockNumber = _b.stockNumber, vehicleId = _b.vehicleId, handleFavorite = _a.utils.handleFavorite, isFavorite = _a.isFavorite;
    var handleOnClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        handleFavorite(stockNumber, vehicleId, isFavorite);
    };
    return (react_1.default.createElement(merch_components_1.Clickable, { "aria-label": "Favorite Vehicle", className: "pointer-events-auto absolute right-[1px] top-[-2px] flex h-44 w-44 items-center justify-center", "data-analytics-id": null, "data-qa": "favorite-vehicle", onClick: handleOnClick },
        react_1.default.createElement(FavoriteIcon_1.default, { isFavorite: isFavorite })));
}
exports.default = FavoriteVehicle;
//# sourceMappingURL=FavoriteVehicle.js.map